import { useQuery } from '@tanstack/react-query';
import { fetchAtlases } from '../api/atlases';

/**
 * All six biome atlases. Atlas data only changes during admin calibration
 * sessions (BP-MAP-ATLAS-03), so a 5-minute staleTime keeps it effectively static
 * for players while still letting refetchOnWindowFocus pick up a save made in
 * another tab: focusing the map tab refetches when the cache is older than 5 min,
 * so a different-tab calibration save is visible within one focus without a hard
 * reload. (Same-tab editor→map saves are already covered by invalidateQueries.)
 */
export function useAtlases() {
  return useQuery({
    queryKey: ['atlases'],
    queryFn: fetchAtlases,
    staleTime: 5 * 60 * 1000,
  });
}
